import * as React from 'react'

import Layout from '../components/Layout/Layout'
import QueryEmulator from '../components/QueryEmulator/QueryEmulator'

const DemoPage = (): JSX.Element => {
  const additionHeaderTag = 
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.12.0/styles/monokai-sublime.min.css"/>
  
  return (
    <Layout footer={false} headers={additionHeaderTag}>
      <div className='demo-page'>
        <div className='demo-content'>
          <QueryEmulator />
        </div>
      </div>
    </Layout>
  )
}

export default DemoPage
